// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {compact, filter, isEmpty, join, get, map, orderBy, pick, set, startCase, uniq} from 'lodash';

// Components
import {Dropdown} from 'primereact/dropdown';
import Button from '../core/button';
import MappingButton from '../app/mapping-button';
import MoviesAndProgramsSearchForm from './movies-and-programs-search-form';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchPanelAction from '../app/services-search-panel-action';
import Thumbnail from '../core/thumbnail';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './movies-and-programs-mapping.scss';
import {DrawLegend, mappingColors} from '../core/colorizeRows';
import rsqlConfig from '../../../config/rsql-config';

const servicesDataKey = 'moviesAndProgramsMappingEpisodes';

class MoviesAndProgramsMappingEpisodes extends Component {
    state = {
        showSearchPanel: false,
    };

    componentWillMount() {
        if (this.getSeriesId()) {
            this.searchByFranchiseEpisodes();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {colorFilterSet} = this.props;
        if (
            nextProps?.colorFilterSet &&
            nextProps?.colorFilterSet[servicesDataKey] &&
            nextProps?.colorFilterSet[servicesDataKey] !== colorFilterSet[servicesDataKey]
        ) {
            this.setState({
                selectedFilter: nextProps?.colorFilterSet[servicesDataKey],
            });
        } else if (nextProps.colorFilterSet && nextProps?.colorFilterSet[servicesDataKey] === null) {
            this.setState({
                selectedFilter: null,
            });
        }
        if (this.getSeriesId() !== this.getSeriesId(nextProps)) {
            this.searchByFranchiseEpisodes(nextProps);
        }
    }

    onFilterChange(e) {
        const {code} = e.value;
        const {servicesDataSearch, setColorFilter, setFieldValue} = this.props;
        this.setState({selectedFilter: code !== 'linkedNot' ? e.value : null});

        setColorFilter(servicesDataKey, code !== 'linkedNot' ? e.value : null);
        setFieldValue(servicesDataKey, 'linkedOnlyFilter', '');
        servicesDataSearch(servicesDataKey);
        if (code !== 'linkedNot') {
            setFieldValue(servicesDataKey, 'linkedOnlyFilter', `=rsql=${rsqlConfig[code]}`);
            servicesDataSearch(servicesDataKey);
        }
    }

    getFranchiseGnSeriesId(props = this.props) {
        const {franchiseData} = props;

        return get(franchiseData, 'gnSeriesId');
    }

    getSeriesId(props = this.props) {
        const {franchiseData} = props;

        return get(franchiseData, 'seriesId')
            ? join(uniq(compact([get(franchiseData, 'seriesId'), get(franchiseData, 'roviProgramId')])), '||')
            : get(franchiseData, 'gnSeriesId');
    }

    getFranchiseSeriesId(props = this.props) {
        const {franchiseData} = props;

        return join(uniq(compact([get(franchiseData, 'seriesId'), get(franchiseData, 'roviProgramId')])), '||');
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxResults: 10000,
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getTablewithsortProps() {
        const {getMappingButtonProps, renderDetail, renderThumbnails} = this.props;

        return {
            className: 'movies-and-programs-mapping--details',
            columnConfig: [
                {
                    dataKey: 'title',
                    formatter: 'moviesAndProgramsTitle',
                    sortKey: 'title.sortable',
                    title: 'Title',
                    width: '17%',
                },
                {
                    dataKey: 'episodeSeason',
                    title: 'S',
                    tooltip: 'Episode Season',
                    width: '5%',
                },
                {
                    dataKey: 'episodeNumber',
                    title: 'E',
                    tooltip: 'Episode Number',
                    width: '5%',
                },
                {
                    dataKey: 'echostarContentType',
                    title: 'Type',
                    tooltip: 'Echostar Content Type',
                    width: '6%',
                },
                {
                    dataKey: 'description',
                    title: 'Description',
                    width: '36%',
                },
                {
                    dataKey: 'releaseYear',
                    title: 'Released',
                    tooltip: 'Release Year',
                    type: 'string',
                    width: '7%',
                },
                {
                    dataKey: 'originalAirDate',
                    title: 'Original Air',
                    tooltip: 'Original Air Date',
                    type: 'date',
                    width: '12%',
                },
                {
                    dataKey: '',
                    title: '',
                    type: 'component',
                    component: MappingButton,
                    componentProps: (searchData) => ({
                        ...getMappingButtonProps(searchData),
                        servicesDataKey,
                    }),
                    width: '12%',
                },
            ],
            rowDetails: {
                blacklistKeys: ['flaggedMetadata'],
                headerRenderer: renderThumbnails,
                renderDetail,
                isMapping: true,
            },
            noRecordsError: 'No matching episodes found.',
            noRecordsChildren: this.renderNoRecordsError,
            noReset: true,
            ...this.props,
        };
    }

    handleCreateShellEpisode = () => {
        const {selectTab} = this.props;

        selectTab('CREATESHELL');
    };

    handleReset = () => {
        this.searchByFranchiseEpisodes();
    };

    handleSearchPanelToggle = () => {
        this.setState({showSearchPanel: false});
    };

    searchByFranchiseEpisodes = (props = this.props, searchField) => {
        const {formValues, mediaItemData = {}, setFieldValues, setQuery, refreshServicesData} = props;
        const seriesId = this.getFranchiseSeriesId(props);
        const gnSeriesId = this.getFranchiseGnSeriesId(props);
        let searchData = {};

        if (searchField) {
            searchData = pick(formValues, ['releaseYear', 'title||seriesTitle']);
            let fieldValue = get(mediaItemData, searchField, '');
            let formField = 'title||seriesTitle';

            if (searchField === 'originalAirDate') {
                formField = 'releaseYear';
                [fieldValue] = fieldValue.split('-');
            } else if (searchField === 'releaseYear') {
                formField = 'releaseYear';
            }

            set(searchData, formField, fieldValue);
        }

        if (seriesId || gnSeriesId) {
            const getId = (id) =>
                Promise.all([
                    setFieldValues(servicesDataKey, {
                        typeFilter: 'episodes_only',
                        [id]: id === 'seriesId' ? seriesId : gnSeriesId,
                        ...searchData,
                    }),
                    setQuery(servicesDataKey, {
                        page: 1,
                    }),
                ]).then(() => refreshServicesData(servicesDataKey));

            if (seriesId) {
                getId('seriesId').then((r) => r);
            } else if (gnSeriesId) {
                getId('gnSeriesId').then((r) => r);
            }
        }
    };

    renderForm = () => (
        <MoviesAndProgramsSearchForm formName={servicesDataKey} noScroll={true} servicesDataKey={servicesDataKey} />
    );

    renderNoRecordsError = () => (
        <div className="movies-and-programs-mapping--buttons">
            <Button className="movies-and-programs-mapping--error-button" onClick={this.handleReset}>
                reset
            </Button>
            <Button className="movies-and-programs-mapping--error-button" onClick={this.handleCreateShellEpisode}>
                Create Shell Episode
            </Button>
        </div>
    );

    renderSearchButton(fieldName) {
        const {mediaItemData = {}} = this.props;
        const props = {
            small: true,
            className: 'movies-and-programs-mapping--search-button',
            onClick: () => {
                this.setState({showSearchPanel: true});
                this.searchByFranchiseEpisodes(this.props, fieldName);
            },
        };
        const fieldValue = get(mediaItemData, fieldName);
        const shouldRender = fieldValue && fieldValue !== '0001-01-01T00:00:00Z';

        return shouldRender ? <Button {...props}>{startCase(fieldName)}</Button> : null;
    }

    renderThumbnails = (searchData) => {
        const images = orderBy(filter(get(searchData, '0.images', []), 'url'), 'category');

        return images.length ? (
            <div className="movies-and-programs-mapping--thumbnail-group">
                {map(images, ({amsGalleryId, category, height, url, width}) => (
                    <Thumbnail
                        className="movies-and-programs-mapping--thumbnail"
                        height={height}
                        key={amsGalleryId}
                        label={startCase(category)}
                        src={url}
                        width={width}
                    />
                ))}
            </div>
        ) : null;
    };

    renderFilters = () => {
        const {className: classNameProp} = this.props;
        const {filters, selectedFilter} = this.state;
        return (
            <div className={`${classNameProp}-filters`}>
                <Dropdown
                    optionLabel="name"
                    options={filters}
                    placeholder="Select a Filter"
                    value={selectedFilter}
                    onChange={(e) => this.onFilterChange(e)}
                />
            </div>
        );
    };

    render() {
        const {className: classNameProp, franchiseData, searchData} = this.props;
        const className = classnames('movies-and-programs-mapping-episodes', classNameProp);
        const {showSearchPanel} = this.state;

        return !isEmpty(franchiseData) ? (
            <div className={className}>
                <div className="movies-and-programs-mapping--search-buttons">
                    {this.renderSearchButton('title')}
                    {this.renderSearchButton('showName')}
                    {this.renderSearchButton('episodeName')}
                    {this.renderSearchButton('releaseYear')}
                    {this.renderSearchButton('originalAirDate')}
                </div>
                <ServicesExportPanelAction exportConfig="moviesAndPrograms" searchData={searchData} />
                <ServicesSearchPanelAction
                    contentRenderer={this.renderForm}
                    showPanel={showSearchPanel}
                    onClick={this.handleSearchPanelToggle}
                />
                <div style={{display: 'flex'}}>
                    <SearchPagination {...this.getPaginationProps()} />
                    {this.renderFilters()}
                    <DrawLegend className="movies-and-programs-mapping--legend" data={mappingColors} />
                </div>
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        ) : null;
    }
}

MoviesAndProgramsMappingEpisodes.propTypes = {
    className: PropTypes.string,
    colorFilterSet: PropTypes.object,
    filterByEpisodes: PropTypes.bool,
    formValues: PropTypes.object,
    franchiseData: PropTypes.object,
    getMappingButtonProps: PropTypes.func.isRequired,
    mediaItemData: PropTypes.object,
    query: PropTypes.object,
    refreshServicesData: PropTypes.func.isRequired,
    renderDetail: PropTypes.func.isRequired,
    renderThumbnails: PropTypes.func.isRequired,
    searchData: PropTypes.array,
    selectTab: PropTypes.func,
    servicesDataSearch: PropTypes.func.isRequired,
    servicesSearchData: PropTypes.object,
    setColorFilter: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setFieldValues: PropTypes.func.isRequired,
    setQuery: PropTypes.func.isRequired,
    totalPages: PropTypes.number,
};

export default withSearch(MoviesAndProgramsMappingEpisodes, servicesDataKey);
